import { render, staticRenderFns } from "./InputSelect.vue?vue&type=template&id=3e8a4db2&"
import script from "./InputSelect.vue?vue&type=script&lang=js&"
export * from "./InputSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/production/spf-sexosafe-ezplatform/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e8a4db2')) {
      api.createRecord('3e8a4db2', component.options)
    } else {
      api.reload('3e8a4db2', component.options)
    }
    module.hot.accept("./InputSelect.vue?vue&type=template&id=3e8a4db2&", function () {
      api.rerender('3e8a4db2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/TestForm/components/InputSelect/InputSelect.vue"
export default component.exports